import React from 'react'
import Header from '../component/Header'
import { useLocation } from 'react-router-dom';
import ExploreResultLocations from '../component/ExploreResultLocations'
import Footer from '../component/Footer'
import HeroBannerSection from '../component/HeroBannerSection'
import WhyPreQualified from '../component/WhyPreQualified'
import QuestionsCTA from '../component/QuestionsCTA'
import GetPreQualifiedComp from '../component/GetPreQualifiedComp' 
import { usePageContent } from "../hooks/usePageContent"; 
function GetPreQualified() {
  const { content, loading } = usePageContent("get-pre-qualified");
  const location = useLocation();
  const hideHero = location.state?.hideHero || false;

  const section = React.useMemo(() => {
    try {
      return JSON.parse(content?.get_pre_qualified_section || "{}");
    } catch {
      return {};
    }
  }, [content]);

  return (
    <>
      <div className='main get-pre-qualified-page'>
        <Header />
        {!hideHero && <HeroBannerSection data={section.section_1} loading={loading} />}
        {hideHero && <GetPreQualifiedComp />}
        <WhyPreQualified data={section.section_2} loading={loading} />
        <QuestionsCTA data={section.section_3} loading={loading} />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}
export default GetPreQualified


